import React, { Component } from "react";

import Grid from "@material-ui/core/Grid";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import Plus from "mdi-material-ui/Plus";

import TitleBar from "../../components/TitleBar";
import TitleBarTitle from "../../components/TitleBarTitle";
import TableCellLink from "../../components/TableCellLink";
import TitleBarButton from "../../components/TitleBarButton";
import DataTable from "../../components/DataTable";
import DeviceAdmin from "../../components/DeviceAdmin";
import ApplicationStore from "../../stores/ApplicationStore";
import {withStyles} from "@material-ui/core/styles";
import { tableSortStyles, bindTableSortHandlers } from "../../classes/tableSort";
import moment from "moment";
import Check from "mdi-material-ui/Check";
import Close from "mdi-material-ui/Close";
import OrganizationBreadcrumps from "../../components/OrganizationBreadcrumps";


const styles ={
    root: {
        width: '100%',
    },

    table: {
        minWidth: 750,
    },
    tableRow:{ backgroundColor: "#f0f0f0"},
    ...tableSortStyles,
};


class ListApplications extends Component {
  constructor() {
    super();
    this.getPage = this.getPage.bind(this);
    this.getRow = this.getRow.bind(this);
    bindTableSortHandlers(this);

    this.state = {
        orderBy:null,
        order:null
    }
  }

  getPage(limit, offset, callbackFunc) {
    ApplicationStore.list("", this.props.match.params.organizationID, limit, offset, callbackFunc,this.state.orderBy,this.state.order);
  }

  getRow(obj) {
    let createdAt = ''
    if(obj.createdAt){
      createdAt = moment(obj.createdAt).format("YYYY-MM-DD HH:mm:ss")
    }
    let icon = null;

    if (obj.isActive) {
      icon = <Check />;
    } else {
      icon = <Close />;
    }
    return(
      <TableRow
      className={!obj.isActive && this.props.classes.tableRow}
        key={obj.id}
        hover={obj.isActive}
      >
        <TableCell>{obj.id}</TableCell>
        <TableCellLink to={`/organizations/${this.props.match.params.organizationID}/applications/${obj.id}/edit`}>{obj.name}</TableCellLink>
        {/* <TableCellLink to={`/organizations/${this.props.match.params.organizationID}/service-profiles/${obj.serviceProfileID}`}>{obj.serviceProfileName}</TableCellLink> */}
        {/* <TableCell>{obj.devCnt}</TableCell>
        <TableCell>{obj.description}</TableCell> */}
        <TableCell>{createdAt}</TableCell>
        <TableCell>{icon}</TableCell>
      </TableRow>
    );
  }

  render() {

    return(
      <Grid container spacing={4}>
        <TitleBar
          buttons={
            <DeviceAdmin organizationID={this.props.match.params.organizationID}>
              <TitleBarButton
                label="Create"
                icon={<Plus />}
                to={`/organizations/${this.props.match.params.organizationID}/applications/create`}
              />
            </DeviceAdmin>
          }
        >
          <OrganizationBreadcrumps org={this.props.org}>
           <TitleBarTitle title="Application Servers" />
          </OrganizationBreadcrumps>
          
        </TitleBar>
        <Grid item xs={12}>
          <DataTable
          orderBy={this.state.orderBy}
          order={this.state.order}
            header={
              <TableRow>
                <TableCell {...this.makeCellSortProps('id')}>{this.makeSortLabel('id','ID')}</TableCell>
                <TableCell {...this.makeCellSortProps('name')}>{this.makeSortLabel('name','Name')}</TableCell>
                {/* <TableCell {...this.makeCellSortProps('service-profile')}>{this.makeSortLabel('service-profile','Service-profile')}</TableCell>
                <TableCell {...this.makeCellSortProps('devices')}>{this.makeSortLabel('devices','Devices')}</TableCell>
                <TableCell {...this.makeCellSortProps('description')}>{this.makeSortLabel('description','Description')}</TableCell> */}
                <TableCell {...this.makeCellSortProps('createdAt')}>{this.makeSortLabel('createdAt','Created at')}</TableCell>
                <TableCell {...this.makeCellSortProps('isActive')}>{this.makeSortLabel('isActive','Active')}</TableCell>
              </TableRow>
            }
            getPage={this.getPage}
            getRow={this.getRow}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(ListApplications);
